import React, { useEffect, useState } from 'react'
import { PostService } from '../../../../Services/ConstantService';
import { API_URL } from '../../../../Services/ApiService';
import { showErrorAlert } from '../../../../Helper/SweetAlert';
import { Link } from 'react-router-dom';
import MoonLoader from 'react-spinners/MoonLoader';
import Pagination from '../../../../Helper/Pagination';

export default function ConnectedCustomers() {

    const [userData, setUserData] = useState();
    const [totalPages, setTotalPages] = useState();
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [S_No_Count, setCount] = useState(1);
    const [id, setId] = useState();
    const [userLimit, setUserLimit] = useState(10);
    const [sorting, setSorting] = useState("contact_id|desc");
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);
    const [selectedState, setselectedState] = useState("");
  
    useEffect(() => {
      getUserList();
    }, [search, currentPage]);
  
    const getUserList = async () => {
      setLoading(true);
      const data = {
        limit: userLimit,
        sorting: sorting,
        page: currentPage,
        search_key: search,
      };
      PostService(API_URL.QUERY_USER_LIST, data).then(
        (res) => {
          console.log(res);
          if (res.data.status === true) {
            setUserData(res?.data?.data);
            setTotalPages(res.data.totalPages);
            setTotal(res.data.totalItems);
            setLoading(false);
          } else {
            showErrorAlert(res.data?.message);
            setLoading(false);
          }
        },
        (err) => {
          showErrorAlert(err.data?.message);
          setLoading(false);
        }
      );
    };

    const handlePageClick = (e) => {
        setCurrentPage(e - 1);
      };

  return (
    <div>
        <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Users Query List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Users Query list</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row px-3">
                    <div className="col-md-4 offset-md-8 p-0">
                      <nav className="navbar p-0">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Keyword"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setSearch(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                    <div class="table-responsive mt-4">
                      {!loading && (
                        <table class="table table-hover table-bordered table-striped">
                          <thead>
                            <tr>
                              <th>S.No</th>  
                              <th>Full Name</th>
                              <th>Email</th> 
                              <th>Message</th> 
                              <th>Contact No.</th> 
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {userData &&
                              userData?.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + currentPage * userLimit + 1}</td> 
                                 
                                  <td>{item?.name}</td> 
                                  <td>{item?.email}</td>
                                  <td>{item?.message.length > 50 ? `${item?.message.substring(0, 50)}.....` : item?.message}</td>
                                  <td>{item?.phone}</td> 
                                  <td> 
                                    <span
                                      title="view"
                                      style={{ cursor: "pointer" }}
                                      className="mx-2"
                                      data-toggle="modal"
                                      data-target="#ViewModal"
                                      onClick={() => {
                                        setselectedState(item);
                                      }}
                                    >
                                      <i className="text-warning fas fa-eye"></i>{" "}
                                    </span>
                                    
                                  </td>
                                </tr>
                              ))}
                            {userData && userData.length === 0 && (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  <h6 className="p-3"> No Data Found </h6>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}

                      {loading ? (
                        <div className="LoaderSpinner">
                          <MoonLoader
                            color={"#003bff"}
                            loading={loading}
                            speedMultiplier={0.6}
                            size={50}
                          />
                          <div>Loading... Please wait.</div>
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="mt-4">
                        <Pagination
                          counting={currentPage * userLimit}
                          totaldata={total}
                          pagecount={totalPages}
                          onChangePage={handlePageClick}
                          activePage={currentPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* / View MODAL-------------------- / */}
      <div
        className="modal fade"
        id="ViewModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-light">
              <h4 className="modal-title" id="exampleModalLabel">
                View User
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="mt-3">  

              <div className="row offset-md-1">
                <div className="col-md-4">
                  <label>Full Name :</label>
                </div>
                <div className="col-md-8 ">
                  <p>{selectedState?.name || "N/A"}</p>
                </div>
              </div> 
              <div className="row offset-md-1">
                <div className="col-md-4">
                  <label>Email :</label>
                </div>
                <div className="col-md-8 ">
                  <p>{selectedState?.email || "N/A"}</p>
                </div>
              </div>  
              <div className="row offset-md-1">
                <div className="col-md-4">
                  <label>Contact No. :</label>
                </div>
                <div className="col-md-8 ">
                  <p>{selectedState?.phone ? selectedState?.phone : "N/A"}</p>
                </div>
              </div>
              <div className="row offset-md-1">
                <div className="col-md-4">
                  <label>Website :</label>
                </div>
                <div className="col-md-8 ">
                  <p>{selectedState?.website || 'N/A'}</p>
                </div>
              </div>
              <div className="row offset-md-1">
                <div className="col-md-4">
                  <label>Message :</label>
                </div>
                <div className="col-md-8 ">
                  <p>{selectedState?.message || "N/A"}</p>
                </div>
              </div> 
            </div>
          </div>
        </div>
      </div>
      {/* / View MODAL- End ------------------- / */}
    </div>
  )
}
